import { TCSPromotionSearchScope } from './TCSPromotionSearchScope';
export const PromotionSearchScopeEnum = TCSPromotionSearchScope;
//# sourceMappingURL=PromotionSearchScopeEnum.js.map